export default {
  state: {
    token: window.sessionStorage.getItem('token') ? window.sessionStorage.getItem('token') : '',
    isLogin: window.sessionStorage.getItem('isLogin') ? window.sessionStorage.getItem('isLogin') : false,
    user_obj: JSON.parse(window.sessionStorage.getItem('user_obj')),
    company_obj: JSON.parse(window.sessionStorage.getItem('company_obj')),
    menu_list: JSON.parse(window.sessionStorage.getItem('menu_list')),
    page_num: 25
  },
  mutations: {
    login (state, token) {
      state.token = token
      state.isLogin = true
      window.sessionStorage.setItem('token', token)
      window.sessionStorage.setItem('isLogin', true)
    },
    logout (state) {
      state.token = ''
      state.isLogin = false
      window.sessionStorage.removeItem('token')
      window.sessionStorage.removeItem('isLogin')
      window.sessionStorage.removeItem('user_obj')
      window.sessionStorage.removeItem('company_obj')
    },
    setUser(state, user_obj) {
      state.user_obj = user_obj
      window.sessionStorage.setItem('user_obj', JSON.stringify(user_obj))
    },
    setCompany(state, company_obj) {
      state.company_obj = company_obj
      window.sessionStorage.setItem('company_obj', JSON.stringify(company_obj))
    },
    setMenu(state, menu_list) {
      state.menu_list = menu_list
      window.sessionStorage.setItem('menu_list', JSON.stringify(menu_list))
    }
  },
  actions: {
    // 登录
    Login({
      commit
    }, token) {
      commit('login', token)
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/home_store.js